import { useQuery } from "@tanstack/react-query";
import { mapSelectOptions } from "../../../utils/map4select";
import { periodicReportKeys } from "./periodicReports.keys";
import { periodicReportsService } from "./periodicReports.service";
import {
  PeriodicReportListFilterPayload,
  PeriodicReportListQueryResponse,
} from "./periodicReports.types";

/**
 * Hook used to fetch data for mfin periodic report list
 * @param pagination Pagination payload
 * @param enabled If true API call is initiated immediately
 * @returns Filter dropdown values that can be applied to data and data after/before data
 */
export function usePeriodicReportList({
  enabled,
  filters,
}: {
  filters: PeriodicReportListFilterPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...periodicReportKeys.periodicReportList({ filters }),
    queryFn: () => periodicReportsService.getPeriodicReportList(filters),
    select: (response): PeriodicReportListQueryResponse => ({
      list: response?.data?.list ?? [],
      periodList: mapSelectOptions<{ id: number; naziv: string }>({
        labelAccessor: "naziv",
        valueAccessor: "id",
        sourceArray: response?.data?.periodList,
      }),
      total: response?.data?.total,
    }),
    retry: false,
    enabled,
  });
}
